import { render } from "./StatusRenovacaoOrcamento.vue?vue&type=template&id=cf3be538&scoped=true"
import script from "./StatusRenovacaoOrcamento.vue?vue&type=script&lang=ts"
export * from "./StatusRenovacaoOrcamento.vue?vue&type=script&lang=ts"

import "./StatusRenovacaoOrcamento.vue?vue&type=style&index=0&id=cf3be538&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cf3be538"

export default script